import * as React from 'react';
import { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { computed, action } from 'mobx';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Chevron from './Chevron';
import DownloadControls from './DownloadControls';
import Translate from './Translate';
import WatchListToggle from './WatchListToggle';
import ChangeIndicator from './ChangeIndicator';
import DocumentMenu from './DocumentMenu';
import Tooltip from './Tooltip';
import { ShareclassCardList, ShareclassCardRow } from './ShareclassCards';
import ColumnDropdown from './ColumnDropdown';

const ShareclassCardLabel = styled<any, any>('div')`
    ${propStyles};
`;

ShareclassCardLabel.defaultProps = {
    fontFamily: "heading",
    fontWeight: "medium"
};

const ShareclassCardValue = styled<any, any>('div')`
    ${propStyles};
`;

ShareclassCardValue.defaultProps = {
    display: "flex",
    alignItems: "center",
    fontFamily: "body",
    fontWeight: "regular"
};

@inject('dataStore')
@observer
class ShareclassCardLabelValue extends Component<any> {

    constructor(props) {
        super(props);

        if (this.props.column.groups) {
            this.setInitialGroupIndex();
        }
    }

    @action
    setInitialGroupIndex = () => {
        const selectedConfigGroupIndex = this.props.column.groups.findIndex(c => c.selected);
        const selectedGroupIndex = this.selectedGroupIndex
            ? this.selectedGroupIndex
            : (selectedConfigGroupIndex > -1)
            ? selectedConfigGroupIndex
            : 0;

        this.props.selectedGroupMap.set(this.props.columnIndex, selectedGroupIndex);
    }

    @computed
    get selectedGroupIndex() {
        return this.props.selectedGroupMap.get(this.props.columnIndex);
    }

    @computed
    get column() {
        // console.log('card column', this.props.column, this.selectedGroupIndex);
        return (this.props.column.groups) ? this.props.column.groups[this.selectedGroupIndex] : this.props.column;
    }

    render() {
        const { theme, dataStore, setSelectedGroup, shareClass } = this.props;
        const { column, selectedGroupIndex } = this;

        if (["group", "dropdown"].includes(column.type)) {
            return (
                <Fragment>
                    {
                        column.type === 'group' ? (
                            <ShareclassCardLabel
                                {...theme.ShareclassCardLabel}
                            >
                                <Translate>{column.label}</Translate>
                                <Tooltip
                                    content={column.disclaimers}
                                />
                            </ShareclassCardLabel>
                        )
                            : (
                                <ColumnDropdown
                                    column={column}
                                    selectedGroupIndex={selectedGroupIndex}
                                    setSelectedGroup={setSelectedGroup}
                                    theme={{
                                        ...theme,
                                        ColumnDropdownWrapper: {
                                            ...theme.ColumnDropdownWrapper,
                                            ...theme.ShareclassCardRowDropdownWrapper
                                        },
                                        ColumnDropdownInnerWrapper: {
                                            ...theme.ColumnDropdownInnerWrapper,
                                            ...theme.ShareclassCardRowDropdownInnerWrapper
                                        },
                                        ColumnDropdownGroupLabel: {
                                            ...theme.ColumnDropdownGroupLabel,
                                            ...theme.ShareclassCardRowDropdownGroupLabel
                                        },
                                        ColumnDropdownChevron: {
                                            ...theme.ColumnDropdownChevron,
                                            ...theme.ShareclassCardRowDropdownChevron
                                        },
                                        ColumnDropdownMenu: {
                                            ...theme.ColumnDropdownMenu,
                                            ...theme.ShareclassCardRowDropdownMenu
                                        },
                                        ColumnDropdownList: {
                                            ...theme.ColumnDropdownList,
                                            ...theme.ShareclassCardRowDropdownList
                                        },
                                        ColumnDropdownListItem: {
                                            ...theme.ColumnDropdownListItem,
                                            ...theme.ShareclassCardRowDropdownListItem
                                        }
                                    }}
                                />
                            )
                    }
                    <ShareclassCardList
                        flex="1 0 100%"
                        paddingX="0"
                    >
                        {
                            column.values.map((c, cIndex) =>
                                <ShareclassCardRow
                                    key={`${c.label}-${cIndex}`}
                                    paddingY="sm"
                                >
                                    {
                                        c.multiple
                                            ?
                                            <Fragment>
                                                <ShareclassCardLabel
                                                    paddingX="md"
                                                    {...theme.ShareclassCardLabel}
                                                >
                                                    <Translate>{c.label}</Translate>
                                                    <Tooltip
                                                        content={c.disclaimers}
                                                    />
                                                </ShareclassCardLabel>
                                                <ShareclassCardValue
                                                    {...theme.ShareclassCardValue}
                                                >
                                                    {
                                                        c.data.map((d, i) =>
                                                            <Fragment
                                                                key={`${d.code}-${i}`}
                                                            >
                                                                <Translate>{d.value}</Translate>{d.separator}
                                                                {
                                                                    d.showChange &&
                                                                    <ChangeIndicator value={d.value} />
                                                                }
                                                            </Fragment>
                                                        )
                                                    }
                                                </ShareclassCardValue>
                                            </Fragment>
                                            :
                                            <Fragment>
                                                <ShareclassCardLabel
                                                    paddingX="md"
                                                    {...theme.ShareclassCardLabel}
                                                >
                                                    <Translate>{c.label}</Translate>
                                                    <Tooltip
                                                        content={c.disclaimers}
                                                    />
                                                </ShareclassCardLabel>
                                                <ShareclassCardValue
                                                    {...theme.ShareclassCardValue}
                                                >
                                                    <Translate>{c.data.value}</Translate>
                                                    {
                                                        c.data.showChange &&
                                                        <ChangeIndicator value={c.data.value} />
                                                    }
                                                </ShareclassCardValue>
                                            </Fragment>
                                    }
                                </ShareclassCardRow>
                            )
                        }
                    </ShareclassCardList>
                </Fragment>
            );
        }

        if (column.type === "download") {
            return (
                <Fragment>
                    <ShareclassCardLabel
                        {...theme.ShareclassCardLabel}
                    >
                        <Translate>{column.label}</Translate>
                        <Tooltip
                            content={column.disclaimers}
                        />
                    </ShareclassCardLabel>
                    <ShareclassCardValue>
                        <DownloadControls
                            count={shareClass.downloadCount}
                            theme={{
                                ...theme,
                                ...{
                                    DownloadButton: theme.ShareclassCardDownloadButton,
                                    DownloadCount: theme.ShareclassCardDownloadCount
                                }
                            }}
                            onClick={e => { e.stopPropagation(); dataStore.downloadDocuments(shareClass.shareClassDownloads); }}
                        />
                        <Chevron
                            direction={shareClass.expanded ? 'down' : 'right'}
                        />
                    </ShareclassCardValue>
                </Fragment>
            );
        }

        if (column.type === "watchlist" && dataStore.watchListEnabled) {
            return (
                <Fragment>
                    <ShareclassCardLabel
                        {...theme.ShareclassCardLabel}
                    >
                        <Translate>{column.label}</Translate>
                    </ShareclassCardLabel>
                    <WatchListToggle
                        onClick={e => { e.stopPropagation(); shareClass.toggleWatchList(); }}
                        active={shareClass.inWatchList}
                        fontSize="1em"
                    />
                </Fragment>
            );
        }

        if (column.type === "document") {
            return (
                <Fragment>
                    {
                        column.value.length > 0
                            ? (
                                <DocumentMenu
                                    documents={column.value}
                                >
                                    <ShareclassCardLabel
                                        {...theme.ShareclassCardLabel}
                                    >
                                        <Translate>{column.label}</Translate>
                                        <Tooltip
                                            content={column.disclaimers}
                                        />
                                    </ShareclassCardLabel>
                                </DocumentMenu>
                            )
                            : (
                                <Fragment>
                                    <ShareclassCardLabel
                                        {...theme.ShareclassCardLabel}
                                    >
                                        <Translate>{column.label}</Translate>
                                        <Tooltip
                                            content={column.disclaimers}
                                        />
                                    </ShareclassCardLabel>
                                    <ShareclassCardValue
                                        {...theme.ShareclassCardValue}
                                    >
                                        <Translate>{dataStore.config.noDataPlaceholder}</Translate>
                                    </ShareclassCardValue>
                                </Fragment>
                            )
                    }
                </Fragment>
            );
        }

        if (column.type === "prices") {
            return (
                <Fragment>
                    <ShareclassCardLabel
                        {...theme.ShareclassCardLabel}
                    >
                        <Translate>{column.label}</Translate>
                        <Tooltip
                            content={column.disclaimers}
                        />
                    </ShareclassCardLabel>
                    <DownloadControls
                        display="inline-flex"
                        onClick={() => shareClass.getPriceHistory(column)}
                        count={1}
                        showCount={false}
                    />
                </Fragment>
            );
        }

        if (column.multiple) {
            return (
                <Fragment>
                    <ShareclassCardLabel
                        {...theme.ShareclassCardLabel}
                    >
                        <Translate>{column.label}</Translate>
                        <Tooltip
                            content={column.disclaimers}
                        />
                    </ShareclassCardLabel>
                    <ShareclassCardValue
                        {...theme.ShareclassCardValue}
                    >
                        {
                            column.data.map((d, i) =>
                                <Fragment
                                    key={`${d.code}-${i}`}
                                >
                                    <Translate>{d.value}</Translate>{d.separator}
                                    {
                                        d.showChange &&
                                        <ChangeIndicator value={d.value} />
                                    }
                                </Fragment>
                            )
                        }
                    </ShareclassCardValue>
                </Fragment>
            );
        }

        return (
            <Fragment>
                <ShareclassCardLabel
                    {...theme.ShareclassCardLabel}
                >
                    <Translate>{column.label}</Translate>
                    <Tooltip
                        content={column.disclaimers}
                    />
                </ShareclassCardLabel>
                <ShareclassCardValue
                    {...theme.ShareclassCardValue}
                >
                    <Translate>{column.data.value}</Translate>
                    {
                        column.data.showChange &&
                        <ChangeIndicator value={column.data.value} />
                    }
                </ShareclassCardValue>
            </Fragment>
        );
    }
}

export default withTheme(ShareclassCardLabelValue) as any;


// WEBPACK FOOTER //
// ./src/Components/ShareclassCardLabelValue.tsx